import React from "react";
import PhoneCallContent from "../components/phoneCalls/phoneCall-content";

const PhoneCalls = () => {
  return <PhoneCallContent />;
};

export default PhoneCalls;
